/**
 * 语言相关常量配置（全局只读）
 *
 * ZH: 中文
 *  - zh
 *
 * EN: 英文
 *  - en
 */
export const LANG: Record<string, any> = {
  // 中文
  ZH: "zh",
  // 英文
  EN: "en",
} as const;
